import { Typography } from 'src/app/components/Elements/Typography';
import type { DeliveryMethod } from 'src/app/types';
import { DeliveryMethodType, ORDER_STATUSES } from 'src/consts';

import { Comma, Container, CourierTimeText, MailTimeText } from './styles';

interface DeliveryTimeEstimateProps {
  orderStatus: ORDER_STATUSES;
  orderStatusLastUpdated: string;
  isDeliveryDelayed: boolean;
  deliveryStartMonthDay: string;
  deliveryHourRange: string;
  deliveryMethod: DeliveryMethod;
}

export const DeliveryTimeEstimate = ({
  orderStatus,
  orderStatusLastUpdated,
  isDeliveryDelayed,
  deliveryStartMonthDay,
  deliveryHourRange,
  deliveryMethod,
}: DeliveryTimeEstimateProps) => {
  const { key: deliveryMethodKey, formattedDeliveryDate, formattedDeliveryTime } = deliveryMethod;
  const isDelivered = orderStatus === ORDER_STATUSES.delivered;
  let deliveryTitle = 'Delivery delayed';

  if (isDelivered) {
    deliveryTitle = orderStatusLastUpdated;
  } else if (!isDeliveryDelayed) {
    deliveryTitle = deliveryHourRange;
  }

  if (deliveryMethodKey === DeliveryMethodType.mail) return <MailTimeText variant="h2">{deliveryTitle}</MailTimeText>;
  else if (deliveryMethodKey === DeliveryMethodType.pickupStation)
    return (
      <>
        <Typography variant="displayXL">{formattedDeliveryDate}</Typography>
        <Typography variant="displayXL">{formattedDeliveryTime}</Typography>
      </>
    );
  else {
    return (
      <Container>
        <>
          {!isDeliveryDelayed && !isDelivered && (
            <>
              <CourierTimeText variant="h2">{deliveryStartMonthDay}</CourierTimeText>
              <Comma variant="h2">,&nbsp;</Comma>
            </>
          )}
          <CourierTimeText variant="h2">{deliveryTitle}</CourierTimeText>
        </>
      </Container>
    );
  }
};
